<aza-rws-profile-header titleTranslationKey="CHANGE_PASSWORD" (closed)="onClosed()"></aza-rws-profile-header>
<div class="profile-change-password-fields-container">
    <div class="section-form-single-column aza-section aza-theme aza-form">
        <div class="aza-section-content aza-section-colors">
            <div class="aza-form-field-area">
                <div class="aza-input-field">
                    <div class="aza-field-content aza-field-type-text">
                        <label class="aza-text" translate>NEW_PASSWORD</label>
                        <input [(ngModel)]="newPassword" type="password" />
                    </div>
                </div>
                <div class="aza-input-field">
                    <div class="aza-field-content aza-field-type-text">
                        <label class="aza-text" translate>CONFIRM_NEW_PASSWORD</label>
                        <input [(ngModel)]="confirmNewPassword" type="password" />
                    </div>
                </div>
                <div *ngIf="newPassword !== confirmNewPassword" class="profile-change-password-no-match">
                    <span translate>PASSWORDS_DO_NOT_MATCH</span>
                </div>
            </div>
        </div>
        <section
            class="section-form-button aza-section aza-theme profile-change-password-confirm-container profile-control-actions-container">
            <div class="aza-section-content aza-section-colors">
                <button (click)="onConfirm()" [disabled]="!newPassword || newPassword !== confirmNewPassword"
                    class="aza-button aza-section-inverted-colors profile-change-password-confirm-button"
                    translate>CONFIRM</button>
            </div>
        </section>
        <section *ngIf="passwordChanged" class="aza-section aza-theme profile-password-has-been-changed-container">
            <span translate>PASSWORD_HAS_BEEN_CHANGED</span>
        </section>
    </div>
</div>